/* ============================================================
   SCENT HARMONY · Pagina de favoritos (/pages/wishlist).
   Pide cada tarjeta guardada por su handle a /products/<handle>?view=wishcard.
   Antes la pagina pintaba TODO el catalogo y escondia lo no guardado, pero
   `collections.all.products` se corta en 50 y con 78 activos los 28 ultimos
   no tenian celda: sets, kits y velas no salian nunca aunque el contador subiera.
   ⚠️ Este codigo vivia en un bloque de script dentro del snippet y NO corria: el
   snippet mencionaba esa misma etiqueta en un comentario de arriba y el compilador emparejaba
   la del comentario con el cierre del final. Aqui, en un asset de verdad, no puede pasar.
   ============================================================ */
(function () {
  var KEY = 'sh-wishlist';
  var wrap = document.querySelector('[data-sh-wishlist]');
  var grid = document.querySelector('[data-sh-wishlist-grid]');
  var empty = document.querySelector('[data-sh-wishlist-empty]');
  if (!wrap || !grid) return;
  var ROOT = wrap.getAttribute('data-root') || '';
  var cache = {};

  function read() { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } }
  function write(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} }

  // Una petición por handle, y solo la primera vez: la promesa se queda en caché.
  function tarjeta(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch(ROOT + '/products/' + encodeURIComponent(handle) + '?view=wishcard', { credentials: 'same-origin' })
        .then(function (r) {
          // 'FUERA' = el producto ya no esta (404) o no va en favoritos (un Add-on
          // devuelve vacio). null = fallo TEMPORAL, y entonces no se toca nada.
          if (r.status === 404) return 'FUERA';
          if (!r.ok) return null;
          return r.text().then(function (t) { return t && t.trim() ? t : 'FUERA'; });
        })
        .catch(function () { return null; });
    }
    return cache[handle];
  }

  function celdas() { return Array.prototype.slice.call(grid.querySelectorAll('[data-wish-handle]')); }

  function estado(cargando) {
    var hay = celdas().length > 0;
    grid.hidden = !hay;
    if (empty) empty.hidden = hay || !!cargando;
  }

  // El orden de la rejilla es el orden en que él los fue guardando.
  function ordenar(saved) {
    var map = {};
    celdas().forEach(function (c) { map[c.getAttribute('data-wish-handle')] = c; });
    saved.forEach(function (h) { if (map[h]) grid.appendChild(map[h]); });
  }

  function pintar() {
    var saved = read();
    // 1) fuera las que ya no están (quitar el ♡ desde aquí mismo)
    celdas().forEach(function (c) {
      if (saved.indexOf(c.getAttribute('data-wish-handle')) < 0) c.remove();
    });
    // 2) traer las que faltan
    var tengo = {};
    celdas().forEach(function (c) { tengo[c.getAttribute('data-wish-handle')] = true; });
    var nuevas = saved.filter(function (h) { return !tengo[h]; });
    estado(nuevas.length > 0);
    if (!nuevas.length) return;

    Promise.all(nuevas.map(tarjeta)).then(function (htmls) {
      var muertas = [];
      nuevas.forEach(function (h, i) {
        if (htmls[i] === 'FUERA') { muertas.push(h); return; }
        // Fallo temporal: se olvida la promesa para reintentar, pero NO se toca la
        // lista guardada. Un fallo de red no puede borrarle los favoritos a nadie.
        if (!htmls[i]) { delete cache[h]; return; }
        var cell = document.createElement('div');
        cell.className = 'sh-wishlist__cell';
        cell.setAttribute('data-wish-handle', h);
        cell.innerHTML = htmls[i];
        grid.appendChild(cell);
      });
      if (muertas.length) {
        write(read().filter(function (h) { return muertas.indexOf(h) < 0; }));
        muertas.forEach(function (h) { delete cache[h]; });
      }
      ordenar(read());
      estado(false);
      // sh-wishlist.js pinta el ♡ de las tarjetas nuevas al oír esto.
      document.dispatchEvent(new CustomEvent('sh-wishlist-render'));
    });
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', pintar); } else { pintar(); }
  document.addEventListener('sh-wishlist-change', pintar);
  document.addEventListener('shopify:section:load', pintar);
})();
